export default "__VITE_ASSET__BVo2mPuj__"